module.exports = __webpack_public_path__ + "img/img32.e17c65b2.png";